import { ProjectType } from "@/graphql"

type Translate = (key: string) => string

type NamedProject = {
	type?: string | null
	name?: string | null
}

export function projectDisplayName(project: NamedProject, t: Translate): string {
	if (project.type === ProjectType.Workspace) return t("project.my-workspace")
	return project.name ?? ""
}
